import React, { useEffect } from 'react';
import OLModifyInteraction from 'ol/interaction/Modify';
import Collection from 'ol/Collection';
import { actionInteractionModifyFeatures } from '../../actions';
import { useLayer } from '../../hooks/useLayer';
import { styleFactory } from '../../utils/styleFactory';
import { useOLMap } from '../MapContext';
export const InteractionModify = React.memo(({ dispatch, layerId, style, selectedFeatureIds, ...options }) => {
    const map = useOLMap();
    const layer = useLayer(layerId);
    useEffect(() => {
        if (!dispatch || !layer)
            return;
        const styleInstance = style ? styleFactory(style) : undefined;
        let featuresCollection;
        if (selectedFeatureIds) {
            featuresCollection = new Collection();
            layer
                .getSource()
                .getFeatures()
                .filter((feature) => selectedFeatureIds.includes(feature.getId() ?? feature.get('id')))
                .forEach((feature) => featuresCollection.push(feature));
        }
        const interaction = new OLModifyInteraction({
            ...options,
            source: layer.getSource(),
            style: styleInstance,
            features: featuresCollection,
        });
        if (process.env.NODE_ENV === 'development') {
            console.log('new OLModifyInteraction', interaction);
        }
        const interactions = map.getInteractions();
        const onModifyEnd = (e) => {
            dispatch(actionInteractionModifyFeatures(layerId, e.features.getArray()));
        };
        interactions.push(interaction);
        interaction.on('modifyend', onModifyEnd);
        return () => {
            interactions.remove(interaction);
            interaction.un('modifyend', onModifyEnd);
        };
    }, [map, layerId, dispatch, options, layer, style, selectedFeatureIds]);
    return null;
});
//# sourceMappingURL=InteractionModify.js.map